import angular from 'angular';
import supportApiModule from '../supportApi.module';

class SupportCaseFeedApiService {
    constructor(__env, $http, $q, tokenProvider) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
        this.tokenProvider = tokenProvider;
    }

    postCaseComment(caseId, formData) {
        var deferred = this.$q.defer();

        this.tokenProvider
            .getBearerTokenHeader('customersupport')
            .then(headers => {
                this.$http
                    .post(
                        `${
                            this.__env.supportApiUrl
                        }/api/v1/cases/${caseId}/comments`,
                        formData,
                        {
                            transformRequest: angular.identity,
                            headers: angular.merge(
                                { 'Content-Type': undefined },
                                headers
                            )
                        }
                    )
                    .then(
                        response => deferred.resolve(response.data),
                        response => deferred.reject(response.data)
                    );
            }, deferred.reject);

        return deferred.promise;
    }
}

export default supportApiModule.service(
    'supportCaseFeedApiService',
    SupportCaseFeedApiService
);



// WEBPACK FOOTER //
// ./modules/supportApi/case-feed/supportCaseFeedApi.service.js